import { render, staticRenderFns } from "./ChangeMailThanks.vue?vue&type=template&id=757f743c&"
import script from "./ChangeMailThanks.vue?vue&type=script&lang=js&"
export * from "./ChangeMailThanks.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports